import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/developers/[slug]/error.tsx");
